import { slicedToArray as _slicedToArray, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { usePathContext } from '../../../context/PathContext.js';
import classNames from 'classnames';
import isValidNumber from './isValidNumber.js';
import LengthInInches from './LengthInInches/index.js';
import StarRatingQuestion from './StarRating/index.js';
import Generic from './Generic/index.js';
import styles from './styles.css.js';

var NumericQuestion = function NumericQuestion(_ref) {
  var question = _ref.question,
      loading = _ref.loading,
      onQuestionUpdated = _ref.onQuestionUpdated,
      onQuestionValidityChanged = _ref.onQuestionValidityChanged;
  var pathContext = usePathContext();
  var numericQuestion = question;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      fieldError = _useState2[0],
      setFieldError = _useState2[1];

  var initialNumericValue = numericQuestion.numericValue ? numericQuestion.numericValue : '';

  var _useState3 = useState(initialNumericValue),
      _useState4 = _slicedToArray(_useState3, 2),
      numericValue = _useState4[0],
      setNumericValue = _useState4[1];

  var handleIsFieldValid = function handleIsFieldValid(value) {
    // First check if this is required question
    if (question.commonFields.required && !value) {
      return false;
    } // Next make sure this value is even a valid number, integer and float both accepted


    if (value && !isValidNumber(value)) {
      return false;
    } // Then run the numeric validations if there are any attached to the field


    return numericQuestion.numericValidations.every(function (validation) {
      if (validation.__typename === 'InRangeNumericValidationQuestionPathNodeFlowViewModel') {
        if (validation.min && value && value < validation.min) {
          return false;
        }

        if (validation.max && value && value > validation.max) {
          return false;
        }
      }

      return true;
    });
  };

  var populateInputValue = function populateInputValue(updatedValue) {
    var _a, _b;

    setNumericValue(updatedValue); // When the field changes, always update the validity response

    var isFieldValid = handleIsFieldValid(updatedValue);
    onQuestionValidityChanged(isFieldValid);
    /**
     * Since Numeric questions will expect a BigDecimal type, an empty string
     * won't suffice for a question that has been answered then unanswered.
     *
     * Reset the value to `null`.
     */

    if (!updatedValue) {
      onQuestionUpdated({
        id: (_a = pathContext === null || pathContext === void 0 ? void 0 : pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
        numericQuestion: {
          questionId: question.id,
          value: null
        }
      });
      setFieldError(false);
    } else {
      onQuestionUpdated({
        id: (_b = pathContext === null || pathContext === void 0 ? void 0 : pathContext.activeNode) === null || _b === void 0 ? void 0 : _b.id,
        numericQuestion: {
          questionId: question.id,
          value: updatedValue
        }
      });
      setFieldError(!isFieldValid);
    }
  };

  useEffect(function () {
    if (initialNumericValue) {
      populateInputValue(initialNumericValue);
    }
  }, []);
  var numericInputClasses = classNames(styles.input, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal'));

  switch (numericQuestion.numericRenderingStyle.__typename) {
    case 'GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel':
      return React.createElement("div", {
        className: numericInputClasses,
        "data-testid": "path-numeric-field-container"
      }, React.createElement(Generic, {
        disabled: loading,
        fieldError: fieldError,
        numericValue: numericValue,
        question: numericQuestion,
        onValueChanged: function onValueChanged(updatedValue) {
          populateInputValue(updatedValue);
        }
      }));

    case 'LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel':
      return React.createElement("div", {
        className: numericInputClasses,
        "data-testid": "path-length-in-inches-field-container"
      }, React.createElement(LengthInInches, {
        disabled: loading,
        fieldError: fieldError,
        numericValue: numericValue,
        onLengthUpdated: function onLengthUpdated(updatedLength) {
          populateInputValue(updatedLength);
        }
      }));

    case 'StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel':
      return React.createElement("div", {
        className: numericInputClasses,
        "data-testid": "path-star-rating-field-container"
      }, React.createElement(StarRatingQuestion, {
        disabled: loading,
        maxRating: numericQuestion.numericRenderingStyle.maxRating,
        numericValue: numericValue,
        onStarSelected: function onStarSelected(starValue) {
          populateInputValue(starValue.toString());
        }
      }));
  }
};

export default NumericQuestion;
//# sourceMappingURL=index.js.map
